import gql from 'graphql-tag';
import { getContextTMC } from '@/utils/tmc';

// NOTE: We inject getContextTMC() directly into the query string
const query = gql`
  query fetchUser($uId: String!, $tripId: String!, $emailId: String) {
    fetchUser(
      userId: $uId
      tripId: $tripId
      emailId: $emailId
      tmc: "${getContextTMC()}"
    ) {
      firstName
      lastName
      email
      userId
      userStatus
    }
    tmcByTripId(tripId: $tripId, tmc: "${getContextTMC()}")
  }
`;

// uId should be a dictionary with uId and tripId as keys e.g: {uId: "123", tripId: "234"}
export default function fetchUser({ apollo, uId, emailId }) {
  return apollo.query({
    query,
    variables: uId,
    emailId
  });
}
